import * as RequestAPI from './request';

export { getServiceRegionsByAddress };

/**
 * Get a list of service regions that apply to this address
 * @link https://chowbus.atlassian.net/wiki/spaces/ENGINEERIN/pages/946602349/Service+Region+API+Contracts
 *
 * @param {ChowbusAddress} address
 * @returns
 */
async function getServiceRegionsByAddress(address) {
  const { data: result } = await RequestAPI.get({
    url: '/api/v2/service_regions',
    data: {
      address_id: address.id,
      latitude: address.latitude,
      longitude: address.longitude,
    },
  });
  return result.data;
}
